import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import {
  FaArrowRight,
  FaCheckCircle
} from 'react-icons/fa';
import './ServicesPage.css';
import mbarblepolishing from "../images/mbarble-polishing.png"
import marbleFloorPolishing from "../images/marble-floor-polishing.png"
import granitePolishing from "../images/granite-polishing.png"
import floorCleaning from "../images/floor-cleaning.png"
import facadeGlassCleaning from "../images/facade-glass-cleaning.png"
import floorScrubbing from "../images/floor-scrubbing.png"
import marbleTilesFixing from '../images/marble-tiles-fixing.png';
import wallpaintingservices from '../images/wall-painting-services.png';
import housePainting from '../images/house-painting-services.png';
import woodenMelaminePolishing from '../images/wooden-melamine-polishing.png';
import homeConstruction from '../images/home-construction.png';
import carpetShampooing from '../images/carpet-shampooing.png';
import officehouserenovation from '../images/office-house-renovation.png';
import stonepolishing from '../images/stone-polishing.jpeg';
import manpowerServices from '../images/manpower-services.png';
import deepCleaning from '../images/deep-cleaning.png';
import carpetCare from '../images/carpet-care.png';
import carpenteryWorks from '../images/carpentery-works.png';
import paintWork from '../images/paint-work.png';

const Services = () => {
  const services = [
    {
      id: 1,
      title: 'Marble Polishing',
      description: 'Professional marble polishing and restoration services to bring back the natural shine and beauty of your marble surfaces. We use advanced techniques and premium products.',
      image: mbarblepolishing,
      features: ['Surface Restoration', 'Stain Removal', 'Sealing & Protection', 'Maintenance']
    },
    {
      id: 2,
      title: 'Granite Polishing',
      description: 'Restore your granite surfaces to a brilliant, mirror-like shine with our expert polishing and care services. Our skilled team ensures long-lasting protection and a flawless finish for your floors and countertops.',
      image: granitePolishing,
      features: ['Honing & Polishing', 'Resealing', 'Regular Maintenance']
    },
    {
      id: 3,
      title: 'Marble Floor Polishing',
      description: `Revive the elegance of your marble floors with our advanced polishing techniques that bring out a smooth, glossy finish.
Our professionals remove stains, scratches, and dullness to restore the natural beauty of your marble.`,
      image: marbleFloorPolishing ,
      features: ['Grinding & Polishing', 'Crystallization', 'Regular Maintenance']
    },
    {
      id: 4,
      title: 'Floor Cleaning',
      description: 'Comprehensive floor cleaning services for all types of flooring including tiles, wood, carpets, and vinyl with professional equipment and eco-friendly solutions.',
      image: floorCleaning,
      features: ['Tile & Grout Cleaning', 'Hardwood Cleaning', 'Carpet Cleaning', 'Deep Sanitization']
    },
    {
      id: 5,
      title: 'Facade Glass Cleaning',
      description: 'Safe and efficient facade glass cleaning for commercial and residential buildings using professional equipment and safety-certified technicians.',
      image: facadeGlassCleaning,
      features: ['High-Rise Cleaning', 'Window Washing', 'Frame Cleaning', 'Solar Panel Cleaning']
    },
    {
      id: 6,
      title: 'Floor Scrubbing',
      description: `eep your floors spotless and hygienic with our deep scrubbing services that remove dirt, grime, and tough stains.
We use advanced machines and eco-friendly solutions to restore your floor’s original shine and smoothness.`,
      image: floorScrubbing,
      features: ['Deep Machine Scrubbing', `Stain Removal`, `Surface Sanitization`]
    },
    {
      id: 7,
      title: 'Marble Tiles',
      description: `Enhance the beauty of your space with premium marble tiles that add elegance and durability to any interior.
Our expert installation and finishing ensure a seamless look with long-lasting shine and strength.`,
      image: marbleTilesFixing,
      features: ['Tile Installation', 'Polishing & Finishing', 'Repair & Replacement']
    },
    {
      id: 8,
      title: 'Wall Painting',
      description: `Give your home or office a fresh and vibrant look with our professional wall painting services.
We use high-quality paints and expert techniques to deliver smooth finishes and lasting color.`,
      image: wallpaintingservices,
      features: ['Interior & Exterior Painting', 'Texture & Design Work', 'Surface Preparation']
    },
    {
      id: 9,
      title: 'House Painting',
      description: `Transform your living spaces with our expert house painting services that bring color, style, and protection to your walls.
Our team ensures flawless finishes using premium-quality paints for a beautiful and long-lasting result.`,
      image: housePainting,
      features: ['Interior Painting', 'Exterior Painting', 'Color Consultation']
    },
    {
      id: 10,
      title: 'Wooden Melamine',
      description: `Enhance the beauty and durability of your wooden furniture and surfaces with our expert melamine polishing services.
We provide a smooth, glossy finish that protects against moisture and wear while highlighting the natural grain of the wood.`,
      image: woodenMelaminePolishing,
      features: ['Surface Sanding', 'Melamine Coating', 'Buff Polishing']
    },
        {
      id: 11,
      title: 'Home Construction',
      description: `Build your dream home with our trusted construction services that combine quality materials, skilled craftsmanship, and modern design.
We ensure timely delivery, structural strength, and aesthetic excellence in every project.`,
      image: homeConstruction,
      features: ['Residential Building Construction', 'Interior Finishing', 'Renovation & Remodeling']
    },
    {
      id: 12,
      title: 'Carpet Shampooing',
      description: `Refresh and renew your carpets with our deep shampooing service that removes dirt, stains, and allergens effectively.
We use advanced cleaning equipment and safe detergents to restore softness and a fresh look to your carpets.`,
      image: carpetShampooing,
      features: ['Deep Cleaning', 'Stain & Odor Removal', 'Fabric Protection']
    },
    {
      id: 13,
      title: 'Office and House Renovation',
      description: `Redesign and upgrade your spaces with our complete renovation solutions that blend functionality and modern style.
From structural improvements to aesthetic enhancements, we deliver quality craftsmanship and timely execution.`,
      image: officehouserenovation,
      features: ['Interior Remodeling', 'Space Planning & Design', 'Electrical & Plumbing Upgrades']
    },
    {
      id: 14,
      title: 'Stone and wall Polishing',
      description: `Restore the natural shine of your stone and wall surfaces with expert polishing.
We remove stains, scratches, and rough patches effectively.
Experience a smooth, glossy, and long-lasting finish.`,
      image: stonepolishing,
      features: ['Wall Polishing', 'Grinding & Polishing', 'Stain Removal', 'Sealing & Maintenance']
    },
    {
      id: 15,
      title: 'Paint Work',
      description: `Add life and color to your space with our professional paintwork services that ensure smooth finishes and lasting protection.
Our skilled painters use premium materials to deliver a flawless look for both interiors and exteriors.`,
      image: paintWork,
      features: ['Interior & Exterior Painting', 'Surface Preparation', 'Finishing & Touch-ups']
    },
    {
      id: 16,
      title: 'Manpower Supply',
      description: `Get reliable and skilled manpower for all your residential, commercial, and industrial needs.
We provide trained professionals to ensure efficiency, quality, and timely completion of your projects.`,
      image: manpowerServices,
      features: ['Skilled & Unskilled Labor', 'Project-Based Staffing', 'Facility Management Support']
    },
    {
      id: 17,
      title: 'Deep Cleaning and Project Cleaning',
      description: `Ensure a spotless and hygienic environment with our thorough cleaning solutions for homes, offices, and post-construction sites.
Our expert team uses advanced tools and eco-friendly products for comprehensive cleaning and sanitization.`,
      image: deepCleaning,
      features: ['Post-Construction Cleaning', 'Floor & Surface Sanitization', 'Furniture & Fixture Cleaning']
    },
    {
      id: 18,
      title: 'Carpentry Work',
      description: `Enhance your space with custom woodwork crafted by skilled professionals for both residential and commercial needs.
We provide reliable, high-quality carpentry solutions that combine functionality with fine craftsmanship.`,
      image: carpenteryWorks,
      features: ['Furniture Making & Repair', 'Door & Window Installation', 'Wood Polishing & Finishing']
    },
    {
      id: 19,
      title: 'Carpet Care Services',
      description: `Keep your carpets looking new and lasting longer with our comprehensive cleaning and maintenance solutions.
Our experts ensure spotless results using advanced equipment and eco-friendly products.`,
      image: carpetCare,
      features: ['Routine Vacuuming & Maintenance', 'Deep Cleaning & Shampooing', 'Stain & Odor Treatment']
    }
  ];

  return (
    <div className="services-page">
      {/* Page Hero */}
      <section className="page-hero services-hero">
        <Container>
          <Row>
            <Col lg={12} className="text-center">
              <span className="page-badge">Our Services</span>
              <h1 className="page-title">Comprehensive Professional Services</h1>
              <p className="page-description">
                We offer a wide range of professional services to meet all your needs. 
                Quality, reliability, and customer satisfaction are our top priorities.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Services Grid */}
      <section className="services-grid-section">
        <Container>
          <Row className="g-4">
            {services.map((service) => (
              <Col key={service.id} lg={4} md={6}>
                <Card className="service-card-detailed h-100">
                  <div className="service-image-wrapper">
                    <img 
                      src={service.image} 
                      alt={service.title}
                      className="service-image"
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.nextSibling.style.display = 'flex';
                      }}
                    />
                    <div className="service-image-placeholder" style={{ display: 'none' }}>
                      <div className="placeholder-icon-large">🏗️</div>
                    </div>
                  </div>
                  <Card.Body className="p-4">
                    <Card.Title className="service-card-title">{service.title}</Card.Title>
                    <Card.Text className="service-card-description">
                      {service.description}
                    </Card.Text>
                    <div className="service-features">
                      <h6 className="features-title">Services Include:</h6>
                      <ul className="features-list">
                        {service.features.map((feature, index) => (
                          <li key={index}>
                            <FaCheckCircle className="feature-check" />
                            {feature}
                          </li>
                        ))}
                      </ul>
                    </div>
                    <Button as={Link} to="/contact" variant="primary" className="service-cta-button">
                      Get Quote <FaArrowRight className="ms-2" />
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* CTA Section */}
      <section className="services-cta-section">
        <Container>
          <Row className="align-items-center">
            <Col lg={8}>
              <h2 className="cta-title">Need a Custom Solution?</h2>
              <p className="cta-description">
                We can customize our services to meet your specific requirements. 
                Contact us today to discuss your project.
              </p>
            </Col>
            <Col lg={4} className="text-lg-end">
              <Button href='tel:+919560424647' variant="light" size="lg" className="cta-button">
                Contact Us Now
              </Button>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Services;

